import Axios from "axios"
import { store } from "../../../store/store";
import { ServiceEndpoints } from "../../constants/AppConstants";
import { getServerID } from "../CommonUtils";

function getBaseUrl() {
    return ServiceEndpoints[getServerID()]['oms']
}

function getHeaders(isJson, attachToken, useUserToken = true) {
    var _headers = { "Content-Type": isJson ? "application/json" : "multipart/form-data" };
    var _hasToken = true
    if (attachToken) {
        const reduxState = store.getState();
        if (useUserToken) {
            _headers['Authorization'] = 'Bearer ' + reduxState.userToken['token'];
        } else {
            _headers['Authorization'] = 'Bearer ' + reduxState.guestToken['token'];
        }
    }
    return { header: _headers, hasToken: _hasToken };
}

export function doPost(urn: String, params: any, attachToken: boolean = true) {
    params['pwa'] = true;
    const headers = getHeaders(true, attachToken)['header'];
    // if (params?.origin && params.origin == 'localhost:19006' || params.origin == 'lap.mcords.co.in' )
    //     params.origin = 'newmedicalstore.mcords.co.in'
    console.log('###, oms api calling #', urn);
    return new Promise((resolve, reject) => {
        Axios.post(getBaseUrl() + urn, JSON.stringify(params), { headers })
            .then(response => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        resolve(response.data.data)
                    } else {
                        console.log('###, Erred on ' + urn + ', ' + response.data.msg)
                        resolve(null);
                    }
                }
            })
            .catch(error => {
                if (error.response?.status == 401 || error.response?.status == 403) {
                    reject({
                        status: 401,
                        msg: 'Invalid_token'
                    });
                } else {
                    reject({ status: 500, msg: 'Internal error. Please try again.' })
                }
            })
    });
}

export function doPostGuest(urn: String, params: any, attachToken: boolean = true) {
    const headers = getHeaders(true, attachToken, false)['header'];
    params['pwa'] = true;
    console.log('###, oms guest api calling #', urn);
    return new Promise((resolve, reject) => {
        Axios.post(getBaseUrl() + 'rcb/' + urn, JSON.stringify(params), { headers })
            .then(response => {
                if (response.status == 200 &&
                    response.data.status == 0) {
                    resolve(response.data.data)
                } else resolve({ 'errMsg': response.data.msg });
            }).catch(error => {
                if (error.response?.status == 401 || error.response?.status == 403) {
                    reject({
                        status: 401,
                        msg: 'Invalid_token'
                    });
                } else {
                    reject({ status: 500, msg: 'Internal error. Please try again.' })
                }
            })
    });
}

export function doMultipart(urn: String, params: Object) {
    const headers = getHeaders(false, true)['header'];
    console.log('###, oms multipart api calling #', urn);
    return new Promise((resolve, reject) => {
        Axios.post(getBaseUrl() + urn, params, { headers })
            .then(response => {
                if (response.status == 200 &&
                    response.data.status == 0) {
                    resolve(response.data.data)
                } else resolve({ 'errMsg': response.data.msg });
            }).catch(error => {
                if (error.response?.status == 401 ||
                    error.response?.status == 403)
                    reject({ status: 401, msg: 'Invalid_token' });
                else reject({ status: 500, msg: 'Internal error. Please try again.' })
            });
    });
}

export function getPharmacyProfilePicture(agentId, pictureName, gpToken) {
    // proofDocPStore
    // profilePicture
    var urn = ServiceEndpoints[getServerID()]['aayu'] + 'v2_agent_picture'
    const uri = urn + '?agentId=' + agentId.toString() + '&pictureName=' + pictureName + '&token=' + gpToken
    return uri
}

export async function createOrder(params) {
    // order_type_digital_erx = 1
    // order_type_physical = 2
    // order_type_search_medicine = 3
    // order_type_specific_products = 4
    params['type'] = 1
    params['medications'] = [{ 'duration': { 'intervalTime': 1, 'intervalUnit': 'Days' } }]
    params['deliveryAddress'] = ''
    params['pharmacies'] = []
    var response = await doPost('order/add', params)
}

export async function SearchMedicine(params) {
    var response = await doPost('/search/medicine', params)
    return response
}

export async function searchSubstitute(params) {
    var response = await doPost('/search/get_substitutes', params)
    return response
}

export async function searchEstablishment(params) {
    var response = await doPost('/gplaces/search', params)
    return response
}

export async function nalistFavoriteAndNearByPharmaciesme(params) {
    var response = {
        'favoitePharmacies': await doPost('/agent/list_favorite_pharmacy', params),
        'nearbyPharmacies': await doPost('/agent/list_nearby_agents', params)
    }
    return response
}